import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a72fc82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewSelect__wrap" }
const _hoisted_2 = {
  key: 0,
  class: "NewSelect__name"
}
const _hoisted_3 = {
  key: 1,
  class: "placeholder__truncate"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Выбрано:", -1))
const _hoisted_5 = { class: "NewSelect__icon" }
const _hoisted_6 = {
  key: 1,
  class: "fas fa-chevron-down arrow"
}
const _hoisted_7 = {
  class: "NewSelect__options",
  ref: "optionswindow"
}
const _hoisted_8 = {
  key: 0,
  class: "options__search"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 3,
  class: "options__empty"
}
const _hoisted_11 = {
  key: 4,
  class: "NewSelect__error"
}
const _hoisted_12 = { class: "error__text" }
const _hoisted_13 = {
  key: 5,
  class: "options__loader"
}
const _hoisted_14 = {
  key: 1,
  class: "NewSelect__validationerror"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (Boolean(_ctx.name))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.name), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["NewSelect", { opened: _ctx.state.is_opened, disabled: _ctx.disabled }]),
      ref: "elementref"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["NewSelect__trigger", { invalid: _ctx.isInvalid }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOptions && _ctx.toggleOptions(...args)))
      }, [
        _createElementVNode("label", {
          class: _normalizeClass(["NewSelect__placeholder", {
                        selected:
                            (!_ctx.multiselect && Boolean(_ctx.value) && Boolean(_ctx.options.length)) ||
                            (_ctx.multiselect && Boolean(_ctx.value.length) && Boolean(_ctx.options.length)) ||
                            ((_ctx.nullableOption || _ctx.customOption) && !Boolean(_ctx.value)),
                    }])
        }, [
          (!_ctx.multiselect && Boolean(_ctx.value) && Boolean(_ctx.options.length))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.selectedOption)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.$slots['option'] && _ctx.$slots['selected-option'])
                        ? _renderSlot(_ctx.$slots, "selected-option", {
                            key: 0,
                            option: _ctx.selectedOption
                          }, undefined, true)
                        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.selectedOption[_ctx.label]), 1))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Выбрано некорректное значение ")
                    ], 64))
              ], 64))
            : (_ctx.multiselect && Boolean(_ctx.value.length) && Boolean(_ctx.options.length))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.selectedOptions.length < 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.$slots['selected-options'])
                          ? _renderSlot(_ctx.$slots, "selected-options", {
                              key: 0,
                              options: _ctx.selectedOptions
                            }, undefined, true)
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_4,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOptions, (selected_option, i) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "ml-2 placeholder__truncate",
                                  key: `selected_option-${i}`
                                }, _toDisplayString(selected_option[_ctx.label]), 1))
                              }), 128))
                            ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Выбрано: " + _toDisplayString(_ctx.selectedOptions.length), 1)
                      ], 64))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.nullableOption && _ctx.nullableText && !_ctx.isCustomChecked)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.nullableText), 1)
                      ], 64))
                    : (_ctx.customOption && _ctx.customText && _ctx.isCustomChecked)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.customText), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_ctx.placeholder), 1)
                        ], 64))
                ], 64))
        ], 2),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary"
              }))
            : (_openBlock(), _createElementBlock("i", _hoisted_6))
        ])
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.searchable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_new_input, {
                autocomplete: false,
                placeholder: "Поиск",
                value: _ctx.state.search_query,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.search_query) = $event)),
                onInput: _ctx.searchOption
              }, null, 8, ["value", "onInput"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.nullableOption && !_ctx.state.search_query)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["options__option", {
                        active:
                            ((!_ctx.multiselect && !_ctx.value) || (_ctx.multiselect && _ctx.value.length === 0)) &&
                            !_ctx.isCustomChecked,
                    }]),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSelectNullableOption && _ctx.onSelectNullableOption(...args)))
            }, _toDisplayString(_ctx.nullableText), 3))
          : _createCommentVNode("", true),
        (_ctx.customOption && !_ctx.state.search_query)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["options__option", {
                        active: _ctx.isCustomChecked,
                    }]),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSelectCustomOption && _ctx.onSelectCustomOption(...args)))
            }, _toDisplayString(_ctx.customText), 3))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedItems, (option, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["options__option", {
                        active:
                            (!_ctx.multiselect && _ctx.value === option[_ctx.selectBy]) ||
                            (_ctx.multiselect && _ctx.value.includes(option[_ctx.selectBy])),
                    }]),
            key: `option-${i}`,
            onClick: ($event: any) => (_ctx.emitSelect(option[_ctx.selectBy]))
          }, [
            (_ctx.$slots['option'])
              ? _renderSlot(_ctx.$slots, "option", {
                  key: 0,
                  option: option
                }, undefined, true)
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(option[_ctx.label]), 1)
                ], 64))
          ], 10, _hoisted_9))
        }), 128)),
        (_ctx.sortedItems.length === 0 && !_ctx.failed && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("p", null, _toDisplayString(_ctx.emptyText), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.failed && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.errorText), 1),
              _createVNode(_component_new_button, {
                onClick: _ctx.emitRefresh,
                class: "primary small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Перезагрузить ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_loader, { class: "primary" })
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ], 2),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true)
  ]))
}